export default "__VITE_ASSET__DOmemkD8__"